import React from 'react'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import Container from 'src/components/atoms/policy/Container'
import Contents from 'src/components/atoms/policy/Contents'
import Content from 'src/components/atoms/policy/Content'
import ChapterName from 'src/components/atoms/policy/ChapterName'
import HeadLine from 'src/components/atoms/policy/HeadLine'

const MembershipAgreement = () => {
  return (
    <div>
      <SEO title="commmune利用規約" />
      <Container>
        <GlobalCSS />
        <Header />
        <SubPageTopLayout
          title="commmune利用規約"
          heading="MEMBERSHIP AGREEMENT"
        />
        <ContentsWrapper>
          <Contents>
            <HeadLine>第１章 総則</HeadLine>
            <ChapterName>第１条 （目的）</ChapterName>
            <Content>
              commmune利用規約（以下「本規約といいます」）は、コミューン株式会社（以下「当社」といいます。）が提供する企業コミュニティサービス「commmune」（以下、「本サービス」といいます。）の利用に関し、当社とお客さまの間に適用されます。お客さまは、本サービスの利用にあたり、本規約に同意したものとみなされます。
            </Content>
            <ChapterName>第２条 （定義）</ChapterName>
            <Content>
              本規約において、次の各号に掲げる用語の意味は、当該各号に定めるとおりとします。
              <br />
              （1） お客さま
              <br />
              本規約に同意の上、当社所定の手続きに従い本サービスの利用を申し込んだ法人、団体、組合または個人をいいます。
              <br />
              （2） コミュニティ
              <br />
              当社が本サービスを提供するために作成・公開するウェブサイトあるいはアプリケーション・ソフトウェアをいいます。
              <br />
              （3） 本サイト
              <br />
              前号のうち、特に当社が本サービスを提供するために作成・公開するウェブサイトをいいます。
              <br />
              （4）本ソフトウェア
              <br />
              前号のうち、特に当社が本サービスを提供するために作成・公開するアプリケーション・ソフトウェアをいい、アップデート版、修正版、代替品および複製物を含みます。
              <br />
              （5） 運用管理者
              <br />
              コミュニティの利用に関する管理者権限を有するお客さま本人あるいは従業員をいいます。
              <br />
              （6） ユーザー
              <br />
              コミュニティへのアカウント登録を完了し、コミュニティを利用する個人をいいます。
              <br />
              （7） ゲスト
              <br />
              コミュニティへのアカウント登録を完了していない状態でコミュニティを利用する個人をいいます。
              <br />
              （8） 登録情報
              <br />
              コミュニティへのアカウント登録時に登録することが求められる、当社が定める一定のユーザーに関する情報をいいます。
              <br />
            </Content>
            <ChapterName>第３条 （規約の変更）</ChapterName>
            <Content>
              当社は、本規約の内容を自由に変更できるものとします。
              <br />
              ２　当社が本規約の内容を変更する場合には、効力発生日の1ヶ月以上前に、その変更内容をお客さまに通知するものとし、通知において指定された効力発生日以降は、変更後の本規約が適用されます。
              <br />
              ３　お客さまが通知において指定された効力発生日以後に本サービスを利用した場合には、変更後の本規約に同意したものとみなします。
            </Content>
            <ChapterName>第４条 （通知）</ChapterName>
            <Content>
              当社は、本サービスに関連してお客さまに通知をする場合には、本サイト・本ソフトウェアに掲示する方法または電子メールなどの電磁的方法により通知を送信する方法など、当社が適当と判断する方法で実施します。
              <br />
              ２　前項に定める方法により行われた通知は、前者の場合には通知内容が本サイト・本ソフトウェアに掲示された時点に、後者の場合は当社が電子メールなどの電磁的方法により通知を発信した時点に、それぞれその効力を生じるものとします。
            </Content>

            <HeadLine>第２章　契約</HeadLine>
            <ChapterName>第５条 （利用契約の成立）</ChapterName>
            <Content>
              お客さまが本サービスの利用を希望する場合、本規約の内容に同意し、お客さまに関する情報・プランなどの契約情報・その他申込の内容を特定するために当社が指定する事項を申込書など当社が指定する方法にて提出することで本サービスの利用契約（以下「本契約」といいます。）の申込を行うものとします。
              <br />
              ２　前項に定める申込に対し当社がこれを受諾した時点で本契約は成立するものとします。
              <br />
              ３　本契約の成立日にかかわらず、本サービスの利用は、当社がお客さまの運用管理者に対してコミュニティの管理者権限を有するアカウントを発行した日より可能となります。
            </Content>
            <ChapterName>第６条 （契約期間）</ChapterName>
            <Content>
              本サービスの契約期間（以下「本契約期間」といいます。）は、第５条２項に定める当社が申込を受諾した時点から、申込時に定めたプラン利用料発生開始日あるいは契約更新日の１年後までの間とします。ただし別段の定めがある場合はその限りではありません。
              <br />
              ２　前項の定めにかかわらず、本契約期間満了日の30日前までに、当社またはお客さまにより書面または電磁的方法により継続停止手続きがなされない限り、本契約は自動的に同内容にて
              1
              年間更新するものとし、以後も同様とします。ただし別段の定めがある場合はその限りではありません。
            </Content>
            <ChapterName>第７条 （プランの変更）</ChapterName>
            <Content>
              お客さまは本契約期間満了日にのみプランを変更できるものとします。ただし、プラン利用料がより高いプランへの変更の場合に限り、その他の期間でも変更ができるものとします。
            </Content>
            <ChapterName>第８条 （契約満了時のデータの取り扱い）</ChapterName>
            <Content>
              契約が満了した場合、あるいは第１２条１項の定めに従いお客さまが本契約を解約した場合、お客さまの要請に基づき当社はデータを消去することができます。
              <br />
              ２　契約が満了した場合、あるいは第１２条１項の定めに従いお客さまが本契約を解約した場合、お客さまは、本サービスにおけるデータのうち、以下の各号に定める内容の提供を当社に請求することができるものとします。当社は当該データをお客さまの請求に基づき電子媒体で提供することとします。そのデータ様式、フォーマット等の一切については当社の定めるものとします。
              <br />
              （1） 本サービスの利用開始日
              <br />
              （2） 本サービス利用開始からの累計使用時間
              <br />
              （3） 本サービス利用開始からの累積起動回数
              <br />
              （4） 本サービス利用開始からの累計投稿・コメント数
              <br />
              （5） 本サービス利用開始からの投稿・コメントの内容
              <br />
              （6） 本サービス利用開始からの累計受領いいね数
              <br />
              （7） 本サービス利用開始からの累計受領コメント数
              <br />
              （8） 本サービス利用開始からの累計イベント参加数
              <br />
              （9） 本サービス利用開始からの累計獲得バッジ数・内容
              <br />
              （10） 本サービス利用開始からの累計獲得ポイント
              <br />
              （11） 本サービス利用開始からの累計達成チャレンジ数とその内容
              <br />
            </Content>
            <ChapterName>第９条 （本契約の解除）</ChapterName>
            <Content>
              当社は、お客さまが次の各号の一つに該当した場合には、お客さまに対して何らの通知催告をすることなく、本契約の全部または一部を解除できます。
              <br />
              （1）
              本規約に違反する行為を行った場合において、催告後相当期間を経過しても当該違反が是正されないとき
              <br />
              （2）
              第１８条および第２０条に定める禁止行為のいずれかを行うなど、本規約に違反する行為を行った場合において、当該違反の性質からして事後の是正が困難であるとき
              <br />
              （3） 暴力団その他の反社会的勢力であると当社が合理的に判断した場合
              <br />
              （4）
              自己振出しの手形又は小切手が不渡処分を受ける等の支払停止状態となったとき
              <br />
              （5）
              仮差押、差押、競売、破産手続開始、会社更生手続開始、民事再生手続開始等の申立があった場合、または公租公課等の滞納処分を受けた場合
              <br />
              （6） 過去に本サービスについて退会処分を受けたことが判明した場合
              <br />
              （7）
              お客さま及び運用管理者が60日以上にわたって所在不明または連絡不能となった場合
              <br />
              （8）
              その他、当社がお客さまとして不適当であると合理的に判断した場合
              <br />
              ２　前項に基づき当社が本契約の解除を行った場合、当社は既に受領した利用料金の返金は行いません。
              <br />
              ３　第１項に基づき当社が本契約の解除を行った場合、当社はお客さまのデータを消去することができます。
            </Content>
            <HeadLine>第３章　利用料金</HeadLine>
            <ChapterName>第１０条 （利用料金及び支払方法）</ChapterName>
            <Content>
              本サービスの利用料金（以下「利用料金」といいます。）は、次の各号に定めるとおりとします。詳細な金額などは当社が別途定める料金表に従うものとします。
              <br />
              （1） プラン利用料
              <br />
              プラン利用料は、お客さまが当社に対して別途提出するお申込書類において特定される料金表記載の金額とします。
              <br />
              （2） 初期費用
              <br />
              本サービスの環境構築、初期設定支援及びお客さまのコミュニティ施策サポートに要する初期費用は、お客さまが当社に対して別途提出する申込書類において特定される料金表記載の金額とします。
              <br />
              （3） 運用支援オプション利用料
              <br />
              運用支援オプション利用料は、お客さまが当社に対して別途提出する申込書類において特定される料金表記載の利用料とします。
              <br />
              （4） ユーザー数に係る従量課金
              <br />
              ユーザー数に係る従量課金お客さまが当社に対して別途提出する申込書類において特定される料金表記載の利用料とします。
              <br />
              ２　お客さまは、当社に対して、本サービスの利用の対価として、利用料金を支払います。詳細な金額および支払条件については、当社の発行する請求書記載のものに従うものとします。
              <br />
              ３　利用料金の支払は、当社の指定する銀行口座に振込むことにより行うものとし、振込み手数料は、お客さまの負担とします。
              <br />
              ４　当社は、いかなる場合にも受領した利用料金の返金には応じません。
            </Content>
            <ChapterName>第１１条 （休止）</ChapterName>
            <Content>
              お客さまは本契約期間中に本サービスの利用、および利用料金の支払を一時的に休止することはできないものとします。
            </Content>
            <ChapterName>第１２条 （中途解約）</ChapterName>
            <Content>
              本契約期間中の本サービスの中途解約はできません。ただし、当社が認めた場合に限り、お客さまは本契約期間満了日までの利用料金合計金額の内未払い分を解約料金として当社に支払うことにより中途解約することができるものとします。
            </Content>

            <HeadLine>第４章　サービスの提供</HeadLine>
            <ChapterName>第１３条 （本サービスの内容）</ChapterName>
            <Content>
              当社はお客さまに対し本サービスを通じてコミュニティタッチによる顧客接点の構築を行うことができるプラットフォーム、及びそれに付随するサービスを提供します。
              <br />
              ２　本サービスのより詳細な内容及び機能等は、当社が別途定めるcommmune機能説明書（以下「本説明書」といいます。）をご参照ください。なお、当社は、本説明書の記載内容を、当社の判断に基づき、事前予告なしに随時追加、変更又は削除等する場合があります。
            </Content>
            <ChapterName>第１４条 （データとバックアップ）</ChapterName>
            <Content>
              本サービスにおいてお客さま・運営管理者・ユーザーのコミュニティの利用に関わるデータ（以下「データ」といいます。）は、すべて当社が委託している本サービス用サーバに保存及び蓄積されます。
              <br />
              ２　当社は、本サービスに関わるデータを定期的なバックアップにより保管します。当社は、バックアップを原則として毎日１回行うものとします。
              <br />
              ３　当社は、システムの障害等によってデータ等が消失した場合、当社がバックアップしたデータ等を用いて復旧するものとします。
              <br />
              ４　当社はデータが消失するリスクをできる限り低くするよう努めますが、遠隔地を含めたデータ保管場所の全てに障害が発生した場合には、データが消失する可能性があります。お客さまは予めこれを承諾するものとし、当社はデータの消失によりお客さまに発生した損害の賠償をする責任を負わないものとします。
            </Content>
            <ChapterName>第１５条 （サービスの停止）</ChapterName>
            <Content>
              当社は、次の各号のいずれかの事由が生じた場合には、事前にお客さまに通知をすることなく、本サービスの一部または全部を停止することができます。この場合、当社はお客さまに事後に通知するものとします。
              <br />
              （1）
              本サービス提供にあたり必要なシステム、設備等に障害が発生し、またはメンテナンス、保守もしくは工事等が必要となった場合
              <br />
              （2）
              電気通信事業者が電気通信サービスの提供を中止するなど、当社以外の第三者の行為に起因して、本サービスの提供を行うことが困難になった場合
              <br />
              （3）
              非常事態（天災、戦争、テロ、暴動、騒乱、官の処分、労働争議等）の発生により、本サービスの提供が困難になった場合、または困難になる可能性のある場合
              <br />
              （4）
              法令規制、行政命令等により、本サービスの提供が困難になった場合
              <br />
              （5）
              その他、当社の責めに帰することができない事由により、当社が必要やむを得ないと判断した場合
              <br />
              ２　当社は、前項に基づいて本サービスを停止したことによりお客さままたは第三者に損害が発生した場合でも、一切の責任を負いません。
            </Content>
            <ChapterName>第１６条 （サービスの変更、中止及び終了）</ChapterName>
            <Content>
              当社は、事前にお客さまに通知をしたうえで、本サービスの一部もしくは全部の内容を変更、中止または終了することができます。但し、変更、中止または終了の内容が重大でない場合には、通知をすることなくこれらを実施することができます。
              <br />
              ２　当社は、前項に基づいて本サービスを変更、中止または終了したことによりお客さままたは第三者に損害が発生した場合でも、一切の責任を負いません。
            </Content>

            <HeadLine>第５章　サービス利用上の注意事項</HeadLine>
            <ChapterName>第１７条 （お客さまの責任）</ChapterName>
            <Content>
              お客さまは、管理者権限を有するアカウントの登録情報を自己の責任において適切に管理及び使用するものとし、これらを用いてなされた一切の行為についてその責任を負います。
              <br />
              ２　お客さまは、ユーザー・ゲスト以外の者に本サービスを利用させてはいけません。
              <br />
              ３　お客さまは、API接続情報を自己の責任において適切に管理及び使用するものとし、これらを用いてなされた一切の行為についてその責任を負います。
              <br />
              ４　お客さまが本サービスを利用するために必要となる通信費（本ソフトウェアのダウンロードおよび利用のために発生する通信費を含む）、および通信機器等は、お客さまの負担と責任により準備するものとします。ただし、お客さまの使用する通信機器等において、本サイトおよび本ソフトウェアが正常に動作することを保証するものではありません。
            </Content>
            <ChapterName>第１８条 （禁止行為）</ChapterName>
            <Content>
              お客さまは、本サービスに関連して次の各号に定める行為を行ってはいけません。
              <br />
              （1） 当社に対して虚偽の申告をする行為
              <br />
              （2）
              本利用規約に基づき当社から提供された本サイト、および本ソフトウェアを含む情報および役務を本サービスの目的以外のために使用する行為
              <br />
              （3）
              当社もしくは第三者の財産（知的財産権を含む。）、プライバシーもしくは信用等を侵害する行為または侵害するおそれのある行為
              <br />
              （4）
              前号以外で当社もしくは第三者の利益を不法に侵害する行為または侵害するおそれのある行為
              <br />
              （5）
              法令に違反し、もしくは公序良俗に反する行為またはそのおそれのある行為
              <br />
              （6）
              コンピュータウィルスなどの有害なプログラムを使用し、もしくは送信する行為、またはそのおそれのある行為
              <br />
              （7）
              第三者のメールアドレスおよびパスワードなど、ログイン情報を不正に使用または取得する行為
              <br />
              （8）
              前号に定めるものの他、不正アクセス行為等当社による業務の遂行、本サービスの実施もしくは当社の電気通信設備に支障を及ぼし、またはそのおそれのある行為
            </Content>

            <HeadLine>第６章　本ソフトウェアの提供</HeadLine>
            <ChapterName>第１９条 （使用許諾）</ChapterName>
            <Content>
              当社は、本サービスの利用に際して本ソフトウェアをダウンロードした利用者に対し、本規約に従うことを条件に、非独占的な使用を許諾します。なお、本ソフトウェアの著作権は当社に帰属します。
            </Content>
            <ChapterName>第２０条 （ソフトウェアに関する禁止事項）</ChapterName>
            <Content>
              お客さまは、本ソフトウェアの利用にあたり、第１８条に定める事項の他、次の各号に定める行為を行ってはいけません。
              <br />
              （1） 本ソフトウェアの複製、翻訳、翻案等の改変を行うこと
              <br />
              （2）
              本ソフトウェアの販売、配布、再使用許諾、公衆送信（送信可能化を含む）、貸与、譲渡、またはリースその他の処分を行うこと
              <br />
              （3）
              本ソフトウェアに設けられたコピーガード等の技術的な保護手段を回避する方法で使用すること
              <br />
              （4）
              本ソフトウェアの一部または全部のリバースエンジニアリング、逆コンパイルもしくは逆アセンブルを行い、またはその他の方法でソースコードを抽出すること
              <br />
              （5） 第三者が複製できるように本ソフトウェアを公開すること
              <br />
              （6）
              前各号に定める他、本ソフトウェアの利用目的に照らして当社が不適切と判断する行為
            </Content>
            <ChapterName>第２１条 （利用制限）</ChapterName>
            <Content>
              次の各号に定める場合、お客さまによる本ソフトウェアの利用の一部または全部が制限されることがあります。
              <br />
              （1）
              利用資格等の確認を目的としたライセンス認証、お客さまID等の認証機能において、利用資格等の確認ができない場合。
              <br />
              （2）
              インターネット接続ができない場所において本ソフトウェアを利用する場合
              <br />
              （3）
              リアルタイム通信ができない通信状況において本ソフトウェアを利用する場合
              <br />
              ２　当社は、本ソフトウェアに関するサポート、修正版（アップデート版を含みます）の提供を行う義務を負いません。またあらかじめお客さまへ通知を行うことなく、本ソフトウェアの修正、変更、アップデート、または提供の終了を行う場合があります。
            </Content>

            <HeadLine>第７章　一般条項</HeadLine>
            <ChapterName>第２２条 （保証）</ChapterName>
            <Content>
              当社は、本サービスが推奨環境において機能するように合理的な最大限の努力を行います。但し、当社は、本サービスを通じて当社が提供し、またはお客さまが取得あるいは利用する情報が正確性、正当性、有用性、完全性等を有することを保証するものではありません。
              <br />
              ２　お客さまは、外部的事情（当社の利用するクラウドサービスにおいて発生した障害や、アプリストアの利用規約改定やアップデート審査、本サービスと連携する当社以外の第三者の提供するサービスの障害などが挙げられますが、これらに限定されません）により、本サービスが正常に動作しない可能性があることにつき承諾するものとします。当該事情によりお客さまに生じた損害について、当社は一切の責任を負いません。
            </Content>
            <ChapterName>第２３条 （知的財産権）</ChapterName>
            <Content>
              本サービスに関する著作権、著作者人格権、特許権、意匠権、商標権及びパブリシティ権等の知的財産権は当社及び正当な権利者たる第三者に帰属し、本契
              約の成立は、お客さまの本サービスの利用に必要な範囲を超える知的財産権の利用許諾を意味するものではありません。
            </Content>
            <ChapterName>第２４条 （損害賠償及び免責）</ChapterName>
            <Content>
              当社は、本サービスに関してお客さまに生じた損害について、現実に生じた通常かつ直接の損害を賠償します。損害額については、損害発生日を終期として過去１年間にお客さまが当社に支払った利用料金を上限として、合理的な因果関係の範囲内において協議の上、取り決めるものとします。
              <br />
              ２　本サービスに関してお客さまとユーザー、あるいはユーザー同士の間に紛争が生じた場合、お客さまは自己の責任と費用で解決するものとし、当社に何ら迷惑をかけず、またこれにより当社が被った損害（弁護士費用を含む。）を補償します。
            </Content>
            <ChapterName>第２５条 （委託）</ChapterName>
            <Content>
              当社は、本サービスに関する業務の一部または全部を第三者に委託することができるものとします（以下その場合の当該第三者を「下請業者」といいます。）。
            </Content>
            <ChapterName>第２６条 （情報管理）</ChapterName>
            <Content>
              当社は、お客さまに関する情報及びデータについて、お客さまの事前の同意を得ずに第三者に開示しません。但し、次の各号の場合はこの限りではありません。
              <br />
              （1）
              法令または公的機関からの要請を受け、要請に応じる必要を認めた場合
              <br />
              （2）
              人の生命、身体または財産の保護のために必要があり、かつお客さまの同意を得ることが困難である場合
              <br />
              （3） サービス提供のために必要な受託者、または代理人
              <br />
              ２　前項にかかわらず、当社は、お客さまに関する情報及びデータについて属性集計・分析を行い、お客さまあるいはユーザーが識別・特定できないように加工したもの（以下「統計資料」といいます。）を作成し、本サービス及び当社のその他のサービスのために利用することがあります。また、統計資料を第三者に開示することがあります。
              <br />
              ３　当社は、お客さまに関する情報及びデータの紛失、破壊、改鼠、漏洩等の危険に対して、合理的な最大限の安全対策を講じます。
              <br />
              ４　当社は、応対品質向上等のため、お客さまとの間の電話・web会議応対を録音し、及び録音内容を業務において使用することができます。
            </Content>
            <ChapterName>第２７条 （秘密情報）</ChapterName>
            <Content>
              お客さま及び当社は、業務上知り得た相手方の技術上、会計上、営業上の情報その他の業務上の情報（以下、「秘密情報」といいます）を、秘密として扱うものとし、相手方の事前の書面による承諾を得ることなく第三者（家族、知人を含む）に漏洩してはならないものとします。
              <br />
              ２　お客さま及び当社は、相手方の書面による承諾を得て、秘密情報を第三者に開示、提供する場合、当該第三者に対し、本条に定めるのと同等の機密保持義務を負わせるものとし、当該第三者の一切の行為につき、責任を負わなければならないものとします。
              <br />
              ３　お客さま及び当社は、相手方の事前の承諾なしに秘密情報を本サービスの提供以外の目的のために使用し、又は複製してはならないものとします。
              <br />
              ４　お客さま及び当社は、法令の定めるところに従い、裁判所その他の公的機関等より秘密情報の開示を要求された場合、かかる要求を受けたことを速やかに相手方に対して通知し、相手方の秘密情報を保護するために必要となる措置を、可能な限り執るものとします。
              <br />
              ５　本契約が終了した場合、又は相手方から要求があった場合には、お客さま及び当社は、秘密情報を直ちに相手方に返還し、又は相手方の指示に従って破棄若しくは消去しなければならないものとします。
              <br />
              ６　本条は、本契約の終了後も2年間効力を有するものとします。
            </Content>
            <ChapterName>第２８条 （個人情報）</ChapterName>
            <Content>
              当社の個人情報の取り扱いについてはプライバシーポリシーに定めるとおりとします。
              <br />
              ２　お客さまは、当社から開示、提供された情報及び資料に、個人情報の保護に関する法律第2条第1項に規定する個人情報が含まれる場合、同法に準拠して当該個人情報を取り扱うものとし、正当な理由なく、第三者に開示、漏洩したり、本サービスの提供以外の目的で使用しないものとします。
            </Content>
            <ChapterName>第２９条 （反社会的勢力等）</ChapterName>
            <Content>
              当社及びお客さまは、相手方に対し、現在及び将来にわたって次の各号の事項を遵守することを確約するものとします。
              <br />
              （1）
              自らが、暴力団、暴力団員、暴力団員でなくなったときから5年を経過しない者、暴力団準構成員、暴力団関係企業、暴力団関係企業の役職員、総会屋、特殊知能犯暴力集団、その他これらに準ずる者（以下、これらを「暴力団員等」という）、暴力団員等に対して資金等を提供し、又は便宜を供与するなどの関係を有している者、暴力団員等と社会的に非難されるべき関係を有する者（以下、これらを総称して「反社会的勢力」という）ではないこと。
              <br />
              （2）
              自らの役員等（業務を執行する従業員、取締役、執行役若しくはこれらに準ずる者又は実質的に経営を支配する者をいう）が反社会的勢力ではないこと。
              <br />
              （3）
              反社会的勢力に自己の名義を利用させ、本契約を締結したものではないこと。
              <br />
              （4） 自ら又は第三者を利用して、次の行為をしないこと。
              <br />
              ア　相手方に対し脅迫的な言動又は暴力を用いる行為
              <br />
              イ　偽計又は威力を用いて相手方の業務を妨害し又は信用を毀損する行為
              <br />
              （5）
              親会社又は子会社（いずれも会社法の定義による。以下同じ）が前４号の事項を遵守すること。
              <br />
              ２　当社及びお客さまは、相手方が前項に違反していることが判明した場合は、何らかの催告を要せず、本契約を解除できるものとします。
              <br />
              ３　当社及びお客さまは、前項により本契約を解除した場合、相手方に損害が生じても何らこれを賠償ないし補償することを要せず、また、かかる解除により当社及びお客さまに損害が生じたときは、被解除者である相手方はその損害を賠償するものとします。
            </Content>
            <ChapterName>第３０条 （権利義務の譲渡禁止）</ChapterName>
            <Content>
              お客さまは、当社の事前の承諾を得ることなく、本契約に基づく権利義務を第三者に譲渡し、または承継させてはならないものとします。
            </Content>
            <ChapterName>第３１条 （協議）</ChapterName>
            <Content>
              本契約の履行について疑義を生じた場合及び本契約に定めのない事項については、当社及びお客さまで協議し、円満に解決を図るものとします。
            </Content>
            <ChapterName>第３２条 （申込書との関係）</ChapterName>
            <Content>
              本規約と、お客さまが提出し当社が受諾した個別の申込書の記載内容との間で矛盾、抵触が生じた場合、個別の申込書の定めが優先するものとします。
            </Content>
            <ChapterName>第３３条 （準拠法、管轄裁判所）</ChapterName>
            <Content>
              本規約及び本契約は、日本法によって解釈され、日本法を準拠法とします。
              <br />
              ２　本契約に関してお客さまと当社の間に紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              <br />
              <br />
              <br />
              <br />
              附則
              <br />
              平成30年 5月 14日　制定・施行
              <br />
              平成30年 7月 18日　改定
              <br />
              令和2年 10月 26日　改定
              <br />
              令和3年 7月 1日　改定
            </Content>
          </Contents>
        </ContentsWrapper>
        <Footer />
      </Container>
    </div>
  )
}

export default MembershipAgreement
